// The GTM guides, programmes and approval (41_Gtm.jsx · ModuleHelp, Max 01/11).
const en = {
  scopeT: 'Mine or everybody\'s',
  scopeB: 'Mine lists the programmes you wrote; All lists every programme, which you can read but not change. The cards and the table follow your choice.',
  kpisT: 'Where the programmes stand',
  kpisB: 'One card per review state. Click a card to list only those programmes; click it again to clear.',
  searchT: 'Search',
  searchB: 'Type a code, a name or a person to narrow the table. Clear resets the search, the cards and every column filter.',
  newT: 'New programme',
  newB: 'Start a GTM programme: give it a name and it opens as a sheet you fill in. You see this button only if you may author.',
  listT: 'The programmes',
  listB: 'One row per programme with its state, regions and SKUs. Open a row to edit it, export a PDF, or send it for approval. Use the funnel on a header to filter.',
  aTabsT: 'Your queues',
  aTabsB: 'Waiting holds the programmes sent for your decision; Approved and Rejected keep the ones already decided. The number on each tab is how many are in it.',
  aListT: 'The programmes sent to you',
  aListB: 'One row per programme with who sent it and when. View opens the full sheet and PDF saves it, so you can read it before you decide.',
  aDecideT: 'Approve',
  aDecideB: 'Approve a programme right from its row once you have read it. You see this button only on programmes you are the approver for.',
};
const ko = {
  scopeT: '내 것 또는 전체',
  scopeB: '내 프로그램은 내가 작성한 것이고, 전체는 모든 프로그램입니다(읽기만 가능). 카드와 표가 선택에 따라 바뀝니다.',
  kpisT: '프로그램 현황',
  kpisB: '검토 상태별로 카드가 있습니다. 카드를 클릭하면 해당 프로그램만 보이고, 다시 클릭하면 해제됩니다.',
  searchT: '검색',
  searchB: '코드, 이름, 담당자를 입력해 표를 좁힙니다. 지우기는 검색, 카드, 열 필터를 모두 초기화합니다.',
  newT: '새 프로그램',
  newB: '이름을 정하면 작성용 시트가 열려 GTM 프로그램을 시작할 수 있습니다. 작성 권한이 있을 때만 이 버튼이 보입니다.',
  listT: '프로그램 목록',
  listB: '프로그램당 한 행으로 상태, 지역, SKU가 나옵니다. 행을 열어 수정하고, PDF로 내보내거나 승인을 요청합니다. 머리글의 깔때기로 필터링합니다.',
  aTabsT: '대기열',
  aTabsB: '대기는 내 결정을 기다리는 프로그램이고, 승인과 반려에는 이미 결정한 프로그램이 있습니다. 탭의 숫자는 건수입니다.',
  aListT: '나에게 온 프로그램',
  aListB: '프로그램당 한 행으로 보낸 사람과 시각이 나옵니다. 보기는 전체 시트를 열고 PDF는 저장하므로, 결정 전에 읽어 볼 수 있습니다.',
  aDecideT: '승인',
  aDecideB: '내용을 읽은 뒤 행에서 바로 프로그램을 승인합니다. 내가 승인자인 프로그램에서만 이 버튼이 보입니다.',
};
const vi = {
  scopeT: 'Của tôi hay của mọi người',
  scopeB: 'Của tôi là các chương trình bạn soạn; Tất cả là mọi chương trình, bạn xem được nhưng không sửa được. Các thẻ và bảng đổi theo lựa chọn này.',
  kpisT: 'Tình trạng các chương trình',
  kpisB: 'Mỗi trạng thái duyệt có một thẻ. Bấm thẻ để chỉ liệt kê các chương trình đó; bấm lại để bỏ lọc.',
  searchT: 'Tìm kiếm',
  searchB: 'Gõ mã, tên hoặc người để thu hẹp bảng. Nút Xóa lọc đặt lại tìm kiếm, các thẻ và mọi bộ lọc cột.',
  newT: 'Chương trình mới',
  newB: 'Bắt đầu một chương trình GTM: đặt tên và nó mở ra thành một bảng để bạn điền. Nút này chỉ hiện khi bạn có quyền soạn.',
  listT: 'Danh sách chương trình',
  listB: 'Mỗi dòng là một chương trình kèm trạng thái, khu vực và SKU. Mở dòng để sửa, xuất PDF hoặc gửi duyệt. Dùng biểu tượng phễu ở tiêu đề cột để lọc.',
  aTabsT: 'Hàng chờ của bạn',
  aTabsB: 'Chờ duyệt là các chương trình gửi đến để bạn quyết định; Đã duyệt và Từ chối giữ các chương trình đã quyết. Số trên mỗi tab là số chương trình trong đó.',
  aListT: 'Chương trình gửi đến bạn',
  aListB: 'Mỗi dòng là một chương trình kèm người gửi và thời điểm gửi. Xem mở toàn bộ bảng còn PDF lưu lại, để bạn đọc kỹ trước khi quyết định.',
  aDecideT: 'Duyệt',
  aDecideB: 'Đọc xong thì duyệt ngay trên dòng của chương trình. Nút này chỉ hiện ở những chương trình bạn là người duyệt.',
};
const zh = {
  scopeT: '我的或全部',
  scopeB: '“我的”是你编写的方案;“全部”是所有方案,你可以查看但不能修改。卡片和表格会随选择变化。',
  kpisT: '方案进度',
  kpisB: '每种审核状态一张卡片。点击卡片只列出对应的方案,再点一次取消。',
  searchT: '搜索',
  searchB: '输入编号、名称或人员来缩小表格。清除会重置搜索、卡片和所有列筛选。',
  newT: '新建方案',
  newB: '开始一个 GTM 方案:起个名字,它会作为一张表单打开供你填写。只有拥有编写权限的人才能看到这个按钮。',
  listT: '方案列表',
  listB: '每个方案一行,显示状态、区域和 SKU。打开某一行可编辑、导出 PDF 或提交审批。用列标题上的漏斗进行筛选。',
  aTabsT: '你的队列',
  aTabsB: '待审是发给你等待决定的方案;已批准和已驳回保存已决定的方案。每个标签上的数字是其中的数量。',
  aListT: '发给你的方案',
  aListB: '每个方案一行,显示发送人和发送时间。查看会打开完整表单,PDF 可保存下来,方便你决定前仔细阅读。',
  aDecideT: '批准',
  aDecideB: '读完后可直接在该行批准方案。只有你是审批人的方案才会显示这个按钮。',
};
const dictionary = { ns: 'tourGtm', en, ko, vi, zh };
export default dictionary;
